export default __webpack_public_path__ + "static/media/login1.4a905b65.png";